<template lang="pug">

    //- THIS IS A DRAFT JADE CODE
    //- TODO: Change to fulfill component view and functionality

    .extra-story(:class="typeClass")

        .extra-story__title
            .extra-story__title__wrap
                h3.h3
                    span(v-if='decorationType === "small"', v-html="'&lt;/div>--></br></'")
                    span(v-if='decorationType === "middle"', v-html="'</'")
                    span(v-if='decorationType === "normal"', v-html="'&lt;?/</br>'")
                    span(v-html='title')
                    span(v-if='decorationType === "small" || decorationType === "middle"', v-html="':/></br>&lt;/b>'")

        .extra-story__wrap
            .extra-story__cta(ref='cta', :class="{disabled: expanded}")
                button(v-html="'-><br />->'", @click="doExpand()", :disabled='expanded')

            .extra-story__content.modal-block(:class="{active: expanded}", ref='modal')

                .modal-block__ui
                    .modal-block__close
                        button(@click="doCollapse()")
                            span
                            span

                    .modal-block__bar
                        //- TODO

                .modal-block__container.swiper-container
                    .swiper-wrapper
                        .modal-block__wrap.swiper-slide
                            .modal-block__text(v-html="text")
                            diagram-block(v-if="content.diagram", :content="content", :active="true", :base="base", :isLiteMode='isLiteMode')
                    .swiper-scrollbar

</template>

<script>
import {TweenLite} from 'gsap';
import Swiper from 'swiper/dist/js/swiper.esm.bundle';
import DiagramBlock from './Diagram.vue';

export default {
    name: 'extra-story',

    props: {
        content: {
            default: () => {
                return {};
            },
            type: Object
        },

        active: {
            default: false,
            type: Boolean
        },

        isLiteMode: {
            default: false,
            type: Boolean
        },

        base: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            expanded: false
        };
    },

    components: {
        DiagramBlock
    },

    computed: {
        title() {
            if (!this.content) return '';
            return this.content.title || '';
        },

        id() {
            if (!this.content) return '';
            return this.content.id || '';
        },

        text() {
            if (!this.content) return '';
            return this.content.text ? this.content.text.join('') : '' || '';
        },

        typeClass() {
            if (!this.content) return '';
            const types = this.content.types;
            if (!types || !(types instanceof Array)) return '';
            const pre = 'extra-story--';
            return pre + types.join(pre);
        },
        decorationType() {
            if (!this.content) return '';
            return this.content.types[0] || '';
        }
    },

    mounted() {
        TweenLite.delayedCall(0.15, this.initSW, [], this);
    },

    beforeDestroy() {
        this.deinitSW();
        this.removeHandler();
    },

    methods: {
        doExpand() {
            if (this.isLiteMode) {
                const elPageY = this.$refs.cta.getBoundingClientRect().top + pageYOffset;
                const headerHeight = parseInt(window.getComputedStyle(document.querySelector('.app-header'), ':before').height);
                window.scrollTo({
                    top: elPageY - headerHeight,
                    behavior: 'smooth'
                });
            }
            this.trackExpand();
            this.expanded = true;
            this.addHandler();
        },

        doCollapse() {
            // this.trackCollapse();
            this.expanded = false;
            this.removeHandler();
        },

        addHandler() {
            document.addEventListener('keyup', this.handlerKey);
            document.addEventListener('click', this.handlerClick);
        },

        removeHandler() {
            document.removeEventListener('keyup', this.handlerKey);
            document.removeEventListener('click', this.handlerClick);
        },

        handlerKey(evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                this.expanded = false;
                this.removeHandler();
            }
        },

        handlerClick(evt) {
            evt = evt || window.event;
            const modalRect = this.$refs.modal.getBoundingClientRect();
            const ctaRect = this.$refs.cta.getBoundingClientRect();
            if (!this.isLiteMode && (evt.x < ctaRect.left || evt.x > modalRect.right || evt.y < modalRect.top || evt.y > modalRect.bottom)) {
                this.expanded = false;
                this.removeHandler();
            }

            if (this.isLiteMode && (evt.x < modalRect.left || evt.x > modalRect.right || evt.y < ctaRect.top || evt.y > modalRect.bottom)) {
                this.expanded = false;
                this.removeHandler();
            }
        },

        initSW() {
            this._swiper = new Swiper(this.$el.querySelector('.swiper-container'), {
                direction: 'vertical',
                slidesPerView: 'auto',
                freeMode: true,
                mousewheel: {
                    enabled: true
                },
                keyboard: {
                    enabled: true
                },
                scrollbar: {
                    el: '.swiper-scrollbar',
                    hide: false,
                    draggable: true
                }
            });
            this._hasSw = true;
        },

        deinitSW() {
            if (this._hasSw) this._swiper.destroy(false, true);
            this._hasSw = false;
            this._swiper = void 0;
        },

        trackExpand() {
            if (this.$analytics !== undefined) {
                /*this.$analytics.sendEvent({
                    event: 'eventTracking',
                    category: 'Popup Expand',
                    action: 'click',
                    label: this.title
                });*/
                this.$analytics.trackView(`Popup: ${this.title}`, `${this.$router.currentRoute.path}#${this.id}`);
            }
        },

        trackCollapse() {
            if (this.$analytics !== undefined) {
                this.$analytics.sendEvent({
                    event: 'eventTracking',
                    category: 'Popup Collapse',
                    action: 'click',
                    label: this.title
                });
            }
        }
    }
};
</script>

<style lang="scss">
//
@import '../assets/css/vars';
@import 'swiper/dist/css/swiper.css';
//
.extra-story {
    position: relative;
    display: flex;
    width: 100%;
    padding: 4.5em var(--width-column-grid) 7em;
    box-sizing: border-box;
    background-color: var(--color-outline-bg);
    margin-bottom: var(--width-column-grid);

    @media (--viewport-mobile), (--viewport-tablet-pt) {
        padding: 3em var(--scr-padding-side) 0;
        margin-bottom: 2rem;
        flex-direction: column;
    }

    &__title {
        width: 50%;
        font-size: 1.714em;
        color: var(--color-accent);

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            width: 100%;
            font-size: 1.2em;
            margin-bottom: 1em;
        }
    }

    &__wrap {
        width: 50%;
        position: relative;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            width: 100%;
        }
    }

    &__cta {
        position: relative;
        top: 5.1em;
        flex-shrink: 0;
        background-color: var(--color-accent-strong);
        color: var(--color-text-over-accent);
        display: inline-block;
        width: 3.6em;
        height: 7.2em;
        animation: accent-strong-bg-blink-short 0.2s linear infinite both;

        &::before,
        &::after {
            content: '';
            display: block;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            transform-origin: 0 0;
        }

        &:after {
            background: var(--color-accent);
            opacity: 0.7;
            z-index: 0;
            animation: noise-anim 2s infinite linear alternate-reverse;
        }

        &:before {
            background: #da9b1b;
            opacity: 0.5;
            z-index: 0;
            animation: noise-anim 5s infinite linear alternate-reverse;
        }

        &.disabled {
            animation: none;

            &::before,
            &::after {
                display: none;
                animation: none;
            }
        }

        button {
            font-size: 1.7em;
            padding: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            &:disabled {
                color: var(--color-text-over-accent);
            }
        }

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            display: block;
            top: 0;
            width: 10em;
            height: 3em;
            padding: 0;
            margin: 0 auto;

            button {
                position: relative;
                left: 5.88em;
                width: 1.76em;
                height: 5.88em;
                transform-origin: left top;
                transform: rotate(90deg);
            }
        }
    }

    &__content {
        position: absolute;
        top: 0;
        left: 3.6em;
        color: var(--color-text-over-accent);
        width: 88%;
        height: 29.4em;
        flex-grow: 1;
        background-color: var(--color-accent-strong);
        padding: 3em 1em 1em 2em;
        opacity: 0;
        pointer-events: none;
        z-index: 2;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            position: absolute;
            top: auto;
            left: 0;
            width: 100%;
            height: 70vh;
            padding: 2em 0.7em;
        }

        @supports (--css: variables) {
            @media (--viewport-mobile), (--viewport-tablet-pt) {
                min-height: calc(var(--vh) * 70);
            }
        }

        .swiper-container {
            height: 100%;
        }

        .swiper-wrapper {
            height: auto;
            padding-right: 3em;
            box-sizing: border-box;
        }

        .swiper-scrollbar {
            width: 1em;
            border-radius: 0;
            background-color: transparent;

            @media (--viewport-mobile), (--viewport-tablet-pt) {
                width: 0.735em;
            }
        }

        .swiper-scrollbar-drag {
            border-radius: 0;
            background-color: var(--color-text-over-accent);
        }

        &.active {
            opacity: 1;
            pointer-events: all;
        }
    }
}

.modal-block {
    &__wrap {
        padding-bottom: 2em;
    }

    &__close {
        position: absolute;
        top: 1em;
        right: 1em;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            top: 0.4em;
            right: 0.55em;
        }

        & button {
            position: relative;
            width: 1.5em;
            height: 1.5em;
            line-height: 1;
            padding: 0 0.05em;

            span {
                position: absolute;
                top: 50%;
                left: 0;
                width: 100%;
                height: 2px;
                display: block;
                background-color: var(--color-text-over-accent);
                transform-origin: center;
                transform: rotate(-45deg);

                &:last-child {
                    transform: rotate(45deg);
                }
            }
        }
    }

    &__text {
        p {
            margin-bottom: 1em;
        }
    }
}
</style>
